module.exports = __webpack_public_path__ + "img/c2.b7cfa57b.jpg";